function setup(form) {
    const buttonElement = document.getElementById('Form_NewsletterPopupForm_action_doNewsletterPopupForm');

    async function submit() {

        try {
            const formData = new FormData(form);
            const response = await fetch(form.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            const result = await response.json();

            let msgEl = form.querySelector('.form-message');
            if (!msgEl) {
                msgEl = document.createElement('div');
                msgEl.className = 'form-message';
                form.prepend(msgEl);
            }

            msgEl.textContent = result.message;
            msgEl.className = `form-message ${result.status}`;

            if (result.status === 'success') {
                const event = new CustomEvent('success', {
                    detail: {
                        time: new Date(),
                    },
                    bubbles: true,
                    cancelable: true
                });
                form.dispatchEvent(event)
            }
        } catch (e) {
            const event = new CustomEvent('fail', {
                detail: {
                    time: new Date(),
                },
                bubbles: true,
                cancelable: true
            });
            form.dispatchEvent(event)

            buttonElement.value = 'Subscribe';
            buttonElement.disabled = false;
        }
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault()

        buttonElement.value = 'Loading';
        buttonElement.disabled = true;

        submit()

        //nocaptcha_handleCaptcha(form, submit);
    })
}

function main() {
    const form = document.querySelector('.newsletter-ajax-form')

    if(!form || form.checkValidity()) return

    setup(form)
}

main()
